import React, { useState } from 'react';
import { Search, Command } from 'lucide-react';
import { cn } from '@/utils/cn';

export interface SearchBarProps {
  onSearch?: (query: string) => void;
  onCommandPalette?: () => void;
  placeholder?: string;
  className?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  onCommandPalette,
  placeholder = 'Search...',
  className,
}) => {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(query);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      if (onCommandPalette) {
        onCommandPalette();
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className={cn('relative', className)}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="w-full pl-10 pr-12 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
          <kbd className="hidden sm:inline-flex items-center px-1.5 py-0.5 border border-gray-200 rounded text-xs font-mono text-gray-500">
            <Command className="w-3 h-3 mr-0.5" />K
          </kbd>
        </div>
      </div>
    </form>
  );
};

export default SearchBar;
